export default __webpack_public_path__ + "43e876231dc64d97253fd1c1967801e8.gif";